import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import classnames from "classnames"
import _ from "lodash"
//************************************//
import InputContainer from "@src/components/helpers/InputContainer"
import LoadingIndicator from "@src/components/LoadingIndicator"
import {trans} from "@utils"
//************************************//
import {_showAssignmentCustomFields} from "../redux/actions"
import MultiBehaviourSelect from "../../../components/MultiBehaviourSelect"

const AssignmentCustomFieldsSelect = props => {
//************************************//
  const {formMethods, defaultValue, options = [], loadOptions = true, outerLoading = false, name, ...restProps} = props
  const {control, errors} = formMethods
//************************************//
  const [loading, setLoading] = useState(false)
  const [localOptions, setLocalOptions] = useState([])
//************************************//
  useEffect(() => {
    if (loadOptions) {
        if (_.size(localOptions) <= 0 && !loading) {
            setLoading(true)
            _showAssignmentCustomFields(data => {
                setLocalOptions(
                    _.map(data, item => ({label: item.name, value: item.key, field_type: item.field_type}))
                )
                setLoading(false)
            })
        }
    } else {
      setLocalOptions(
          _.map(data, item => ({label: item.name, value: item.key, field_type: item.field_type}))
      )
    }
  }, [options])
//************************************//
  return (
      <LoadingIndicator loading={loading || _.size(localOptions) <= 0 || outerLoading}>
        <InputContainer
            control={control}
            type={'uncontrolled-custom-input'}
            as={MultiBehaviourSelect}
            className={classnames({'is-invalid': _.get(errors, `${name}`)})}
            name={`${name}`}
            options={localOptions}
            defaultValue={(defaultValue && _.find(localOptions, x => x?.value === defaultValue)) ? _.find(localOptions, x => x?.value === defaultValue) : ''}
            rules={{
              required: trans('checklist.validation.required')
            }}
            {...restProps}
        />
      </LoadingIndicator>
  )
}

AssignmentCustomFieldsSelect.propTypes = {

}

export default AssignmentCustomFieldsSelect
